/*
 * @Author: Daokai Huo
 * @Date: 2021-10-19 19:28:26
 * @LastEditTime: 2021-10-19 19:35:00
 * @Description:
 */
import IonForm from './src/ion-form.vue';

IonForm.install = function install(_vue) {
  _vue.component(IonForm.name, IonForm);
};
export default IonForm;
